export default __webpack_public_path__ + "static/media/logo.e84bf5d2.png";